<template>
    <div class="" >

    <b-row class=" justify-content-md-center ">

      <b-col xl="3" md="6">
         <Pix></Pix>
      </b-col>

      <!-- <b-col xl="3" md="6"  >
       <Boleto></Boleto>
      </b-col> -->

      <b-col xl="3" md="6"  >
        <PixBoleto></PixBoleto>
      </b-col>
 
     
    </b-row>
  
    <b-row  class="mt-3 justify-content-md-center ">
          <b-col cols="12" md="12">
                <ListaOrdem></ListaOrdem>

          </b-col>
    </b-row>


    </div>
</template>
<script>
import {  BButton, BSpinner,BCard, BAvatar, BCardText, BLink,BRow, BCol} from 'bootstrap-vue'
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Pix from "./cobranca/Pix.vue";
import Boleto from "./cobranca/Boleto.vue";
import PixBoleto from "./cobranca/PixBoleto.vue";
import Ordem from '../Ordem.vue';
import ListaOrdem from './cobranca/ListaOrdem.vue';
export default {
    components: {
    BButton,
    BSpinner,
    BCard,
    BAvatar,
    BCardText,
    BLink,
    BRow,
    BCol,
    Pix,
    Boleto,
    PixBoleto,
    Ordem,
    ListaOrdem
},
  
    data() {
        return {
            status: "",
            password: "",
            show: false,
            isDisabled: false,
            spiner:false,

            estabelecimento: {
                name: null,
                cnpj: null,
                id: null,
                email: null,
                apiKey: null,
                responsible:null
            },
        }
    },

  watch:{
      estabelecimento(value){
        this.BuscarOrder(value)
     }
  },
  computed: {
    usuario() {
      return this.$store.state.login.usuario;
    },
    lista_estabelecimentos() {
      return this.$store.state.estabelecimentos.lista_estabelecimentos.data;
    },

  },

  methods: {
    

  async  SalvarEstabelecimento(){
    this.spiner = true
    this.isDisabled = true
      const dados = {
         name: this.estabelecimento.name,
         cnpj: this.estabelecimento.cnpj,
         email: this.estabelecimento.email,
         company_id: this.usuario.companyId,
         responsible:this.estabelecimento.responsible
      }

       console.log(dados)

      await this.$store
        .dispatch("estabelecimentos/cadastrar", dados)
        .then((data) => {

            this.$toast({
            component: ToastificationContent,
            props: {
              title: "Salvo com sucesso",
              icon: "EditIcon",
              variant: "success",
            },
          });
          this.show = false
          this.spiner = false
         
        })
        .catch((error) => {
           this.spiner = false
          this.isDisabled = false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Erro:" + error,
              icon: "EditIcon",
              variant: "danger",
            },
          });
         
        });
      
     
    },
    showModalSenha(item) {
      this.isDisabled = true;
      this.estabelecimento = {
        id: item.id,
        name: item.name,
        cnpj: item.cnpj,
        email: item.email,
        apiKey: item.apiKey,
      };
      this.show = true;
    },
    showModalNovo() {
      this.estabelecimento = {
        id: null,
        name: null,
        cnpj: null,
        email: null,
        apiKey: null,
      };
    //   this.isDisabled = false;
      this.show = true;
    },
  },
};
</script>
    
<style lang="">
    
</style>